import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

interface IHttpResponse {
  error_code: number;
  error_msg;
  string;
  data: any;
}

interface IOperateDetail {
  id: number;
}

interface IGetTaskLogList {
  page: number;
  page_size: number;
  begin?: string;
  end?: string;
  operator_relation_id?: number;
  group?: Array<number>;
  search_words?: string;
  search_type?: "schedule_task" | null;
}

interface IUpdateTask {
  id: number;
  expected_date: string;
  expected_time: string;
  level: number;
  currency_type: string;
  fee: number;
  note?: string;
  status?: number;
  photos?: Array<any>;
  house_id?: number;
  schedule_staff_id?: number;
  gen_transaction?: number;
}

interface IGetTaskList {
  expected_begin?: string;
  expected_end?: string;
  schedule_staff_id?: number;
  house_ids?: Array<number>;
  type?: number;
  status?: number;
  page?: number;
  page_size?: number;
  direction?: string;
}

const GET_TASK_DETAIL_API = "/api/schedule/task/detail";
const GET_LOG_LIST_API = "/api/log/list";
const UPDATE_TASK_API = "/api/schedule/task/update";
const DELETE_TASK_API = "/api/schedule/task/delete";
const GET_TASK_LIST_API = "/api/schedule/task/list";

@Injectable({
  providedIn: "root",
})
export class TaskDetailService {
  closeDrawer$ = new Subject<void>();

  constructor(private http: HttpClient) {}

  /** 计划任务详情 */
  getTaskDetail(params: IOperateDetail) {
    const query = new HttpParams().append("id", `${params.id}`);
    return this.http.get(GET_TASK_DETAIL_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }

  /** 获取日志列表 */
  getLogList(params: IGetTaskLogList) {
    const query = new HttpParams()
      .append("page", `${params.page}`)
      .append("page_size", `${params.page_size}`)
      .append("begin", `${params.begin}`)
      .append("end", `${params.end}`)
      .append("operator_relation_id", `${params.operator_relation_id}`)
      .append("group", `${params.group}`)
      .append("search_words", `${params.search_words}`)
      .append("search_type", `${params.search_type}`);
    return this.http.get(GET_LOG_LIST_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }

  /** 更新任务 */
  updateTask(params: IUpdateTask) {
    return this.http.post(UPDATE_TASK_API, params) as Observable<IHttpResponse>;
  }

  requestUpdateCheckListStatus(params: any) {
    return this.http.post("/api/schedule/task/update_check_list_status", params);
  }

  /** 删除任务 */
  deleteTask(params: IOperateDetail) {
    return this.http.post(DELETE_TASK_API, params) as Observable<IHttpResponse>;
  }

  /** 计划任务列表 */
  getTaskList(params) {
    const query = new HttpParams()
      .append("expected_begin", `${params.expected_begin}`)
      .append("expected_end", `${params.expected_end}`)
      .append("schedule_staff_id", `${params.schedule_staff_id}`)
      .append("house_ids", `${params.house_ids}`)
      .append("type", `${params.type}`)
      .append("status", `${params.status}`)
      .append("page", `${params.page}`)
      .append("page_size", `${params.page_size}`)
      .append("direction", `${params.direction}`);
    return this.http.get(GET_TASK_LIST_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }
}
